import { ProgressComponents } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/_shared/ProgressComponents';
import { ProgressWorkflow } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/ProgressWorkflow/WithProgressWorkflow/components/ProgressWorkflow';
import { AbstractProgressWorkflow } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/ProgressWorkflow/AbstractProgressWorkflow';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { StyledAccordion } from '@/components/shared/components/StyledAccordion';

interface ProgressWorkflowAccordionProps {
  progress: AbstractProgressWorkflow;
}

export const ProgressWorkflowAccordion = ({ progress }: ProgressWorkflowAccordionProps) => {
  return (
    <StyledAccordion.Accordion style={{ width: '100%' }}>
      <StyledAccordion.AccordionSummary
        disabled={!progress?.isValid}
        style={{ marginTop: '0', display: 'flex', alignItems: 'center' }}
        expandIcon={<ProgressComponents.ExpandMoreIcon />}
      >
        {progress?.isValid ? (
          <FlexRow width={'100%'} height={48}>
            <ProgressComponents.Status
              isActive={progress.isActive}
              title={progress.statusTextId}
              subtitle={progress.workflow.place.name}
            />
            <ProgressComponents.HistoryButton label="APPLICATION_HISTORY" />
          </FlexRow>
        ) : (
          <ProgressComponents.InvalidStatus />
        )}
      </StyledAccordion.AccordionSummary>
      <StyledAccordion.AccordionDetails>
        {progress?.isValid && <ProgressWorkflow progress={progress} />}
      </StyledAccordion.AccordionDetails>
    </StyledAccordion.Accordion>
  );
};
